<template>
	<div class="help-tree">
		<div v-for="item in data" :key="item.id">
			<div v-html="item.content" :id="'anchor' + item.id" :class="{ active: item.id == active }" style="padding: 5px 10px"></div>
			<help-tree v-if="item.childList && item.childList.length" :data="item.childList" :active="active"></help-tree>
		</div>
	</div>
</template>

<script>
	export default {
		name: "helpTree",
		props: {
			data: {
				type: Array,
				default: []
			},
      active: {
        type: String,
        default: ''
      }
		},
		data() {
			return {

			}
		}
	}
</script>

<style lang="scss" scoped>
.active {
  background-color: rgba(230, 255, 64, 0.13);
  /* padding: 5px 0; */
  transition-duration: all .1s;
}
/deep/a {
  color: blue;
  text-decoration: underline;
  &:hover {
    color: blue;
    text-decoration: underline;
  }
  &:active {
    color: blue;
    text-decoration: underline;
  }
}
</style>
